import type { TimesheetFormat } from "../types";

export function timesheetFallbackFilename(
	month: string,
	format: TimesheetFormat,
): string {
	return `folha-de-horas-${month}.${format}`;
}

export function saveBlob(blob: Blob, filename: string): void {
	const url = URL.createObjectURL(blob);
	try {
		const anchor = document.createElement("a");
		anchor.href = url;
		anchor.download = filename;
		anchor.rel = "noopener";
		document.body.appendChild(anchor);
		anchor.click();
		anchor.remove();
	} finally {
		setTimeout(() => URL.revokeObjectURL(url), 10_000);
	}
}
